import React from 'react';
import { createBrowserRouter } from "react-router-dom";
import { AdminTools, adminToolsRoutes, dashboardRoutes, RouteConstants } from "./Routes";
import Dashboard from "./components/dashboard/Dashboard.component";
import Login from "./pages/login/Login.component";
import CreateUser from './pages/login/CreateUser.component';
import { NewAccountRoute } from './pages/login/SignupEmbed.component';
import VerifyEmail from './pages/login/VerifyEmail.component';
import ForgotPassword from './pages/login/ForgotPassword.component';
import ResetPassword from './pages/login/ResetPassword.component';
import ApiDocs from './pages/settings/api_keys/ApiDocs.component';
import InteriorShare from './pages/interior_share/InteriorShare.component';
import BookingPage from './pages/book/BookingPage.component';
import BookingManage from './pages/book/BookingManage.component';
import BookingConfirm from './pages/book/BookingConfirm.component';
import GetStarted from './pages/get_started/GetStarted.component';
import PublicPricing from './pages/pricing/PublicPricing.page';
import PublicInspo from './pages/inspo/PublicInspo.page';
import ViewAsEnded from './pages/view_as/ViewAsEnded.component';
import EmailPreferences from './pages/marketing/public/EmailPreferences.component';
import EmailConfirm from './pages/marketing/public/EmailConfirm.component';
import MarketingConnect from './pages/marketing/connect/MarketingConnect.component';

export const router = createBrowserRouter([
    {
        element: <Dashboard />,
        children: [
            ...dashboardRoutes,
            // Nested rather than flat so AdminTools' <Outlet /> resolves and the
            // left admin nav survives on sub-pages like /admin-tools/mockups/12.
            {
                path: RouteConstants.ADMIN_TOOLS,
                element: <AdminTools />,
                children: adminToolsRoutes
            }
        ]
    },
    {
        element: <ApiDocs />,
        path: RouteConstants.API_DOCS
    },
    {
        element: <InteriorShare />,
        path: RouteConstants.INTERIOR_SHARE
    },
    // Public, no login: a rep's booking page and an invitee's own booking.
    {
        element: <BookingPage />,
        path: RouteConstants.BOOK
    },
    {
        element: <BookingPage />,
        path: RouteConstants.BOOK_TEAM
    },
    {
        element: <BookingManage />,
        path: RouteConstants.BOOK_MANAGE
    },
    {
        element: <BookingConfirm />,
        path: RouteConstants.BOOK_CONFIRM
    },
    // Public, no login: the "Manage preferences" link in every marketing email, and double opt-in.
    {
        element: <EmailPreferences />,
        path: RouteConstants.EMAIL_PREFERENCES
    },
    {
        element: <EmailConfirm />,
        path: RouteConstants.EMAIL_CONFIRM
    },
    // Signed in, but outside the dashboard shell: the OAuth consent page an app (claude.ai, ChatGPT) opens.
    // It sends signed-out visitors to /login and back with ?request= intact.
    {
        element: <MarketingConnect />,
        path: RouteConstants.MARKETING_CONNECT
    },
    // Public: the website's Get started form, embeddable on any site with /embed/get-started.js.
    {
        element: <GetStarted />,
        path: '/get-started'
    },
    // Public: artist pricing, embeddable on any site with /embed/pricing.js.
    {
        element: <PublicPricing />,
        path: '/pricing'
    },
    // Public: brand stories (Inspo), embeddable on any site with /embed/inspo.js.
    {
        element: <PublicInspo />,
        path: '/stories'
    },
    {
        element: <ViewAsEnded />,
        path: '/view-as/ended'
    },
    {
        element: <ViewAsEnded />,
        path: '/view-as'
    },
    {
        element: <Login />,
        path: '/login'
    },
    {
        element: <CreateUser />,
        path: '/new-user'
    },
    {
        element: <NewAccountRoute />,
        path: '/new-account'
    },
    {
        element: <VerifyEmail />,
        path: '/verify'
    },
    {
        element: <ForgotPassword />,
        path: '/forgot-password'
    },
    {
        element: <ResetPassword />,
        path: '/reset-password'
    }
]);